import React, { useCallback, useMemo } from "react";
import { Pressable } from "react-native";
import { useI18nMessage } from "@lookiero/i18n-react";
import { Text } from "@lookiero/sty-psp-ui";
import { Checkbox } from "@lookiero/sty-psp-ui";
import { useAnswerForId } from "../../behaviours/useAnswers";
import { useAnswersValidation } from "../../behaviours/useAnswersValidation";
import { style as checkboxQuestionItemStyle } from "./CheckboxQuestionItem.style";
const CheckboxQuestionItem = ({ domain, segment, question, questionParentId }) => {
    const style = useMemo(() => checkboxQuestionItemStyle(), []);
    const titleText = useI18nMessage({ domain, id: question.translationKey, values: { segment: segment.toLowerCase() } });
    const { answer, onChange } = useAnswerForId({ id: questionParentId });
    const selectedAnswer = answer && answer.find((id) => id === question.id);
    const { validateMaxAnswers } = useAnswersValidation();
    const handleOnPress = useCallback(() => {
        onChange({ questionId: question.id, answer: selectedAnswer ? undefined : question.id });
        validateMaxAnswers();
    }, [onChange, question.id, selectedAnswer, validateMaxAnswers]);
    const checked = Boolean(selectedAnswer);
    return (React.createElement(Pressable, { accessibilityLabel: "checkbox-question-item", accessibilityState: { checked }, style: style.checkbox, testID: "checkbox-question-item", accessible: true, onPress: handleOnPress },
        React.createElement(Checkbox, { checked: checked }),
        React.createElement(Text, { level: 1, style: style.text, variant: "detail" }, titleText)));
};
export { CheckboxQuestionItem };
